import * as React from 'react';

import { AreaPartsTable } from '../../../../components/Commercial/AreaPartsTable';
import { useOfferContext } from '../../../../context';
import { getMultiAdsAreaPartType } from '../../../../utils/computedProps/commercial/multiAds/getMultiAdsAreaPartType';
import { isCommercialMultiAds } from '../../../../utils/computedProps/commercial/multiAds/isCommercialMultiAds';

const TRACKING_LABEL = 'card_areas_in_newlist';

export function CommercialAreaPartsContainer() {
  const {
    offer,
    tracking,
    api: { onPageJumped },
  } = useOfferContext();

  const handleAreaPartClick = React.useCallback(() => {
    tracking.trackMultiOfferClick(TRACKING_LABEL);
    onPageJumped(TRACKING_LABEL);
  }, [tracking, onPageJumped]);

  if (!isCommercialMultiAds(offer) || !offer.fullUrl) {
    return null;
  }

  const isRent = offer.dealType === 'rent';
  const typeLabel = getMultiAdsAreaPartType(offer);
  const areaParts = offer.areaParts ?? [];

  return (
    <AreaPartsTable
      areaParts={areaParts}
      fullUrl={offer.fullUrl}
      isRent={isRent}
      typeLabel={typeLabel}
      onAreaPartClick={handleAreaPartClick}
    />
  );
}

CommercialAreaPartsContainer.displayName = 'CommercialAreaPartsContainer';
